import React, { useEffect, useRef, useState } from "react";
import i18n from "../../../modules/Auth/pages/i18n";
import { useTranslation } from "react-i18next";

const SearchableDropdown = ({
  options,
  label,
  id,
  selectedVal,
  handleChange,
  selectedLanguage,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", toggle);
    return () => document.removeEventListener("click", toggle);
  }, []);

  const selectOption = (option) => {
    setQuery(() => "");
    handleChange(option[label]);
    setIsOpen((isOpen) => !isOpen);
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    if (query) return query;
    if (selectedVal) return selectedVal;

    return "";
  };

  const filter = (options) => {
    // debugger;
    return options.filter(
      (option) => option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
    );
  };

  return (
    <>
      <div className="dropdown">
        <div className="control">
          <div className="selected-value">
            <input
              ref={inputRef}
              type="text"
              value={getDisplayValue()}
              autoFocus={inputRef.current === document.activeElement}
              name="searchTerm"
              placeholder={t("Enter Tax Identification Number")}
              onChange={(e) => {
                setQuery(e.target.value);
                handleChange(e.target.value);
              }}
              onClick={toggle}
            />
          </div>
          <div className={`arrow ${isOpen ? "open" : ""}`}></div>
        </div>

        <div className={`options ${isOpen ? "open" : ""}`}>
          {filter(options).map((option, index) => {
            return (
              <div
                onClick={() => selectOption(option)}
                className={`option ${
                  option[label] === selectedVal ? "selected" : ""
                }`}
                key={`${id}-${index}`}
              >
                {`${option[label]} - ${option["company_name"]} `}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SearchableDropdown;
